import * as React from 'react';
import { ArticleHeading2, ArticleHeading3, Label, TDeviceType } from '@cian/ui-kit';
import { clsx } from 'clsx';

import * as styles from './BuildersPromotions.css';
import { IBiggestBuildersPromos } from '../../types/promosPage/biggestBuildersPromos';

interface IBuildersPromotions {
  deviceType: TDeviceType;
  biggestBuildersPromos: IBiggestBuildersPromos;
}

const MAX_ICONS = 10;

export const BuildersPromotions: React.FC<IBuildersPromotions> = ({ deviceType, biggestBuildersPromos }) => {
  const { label, title, searchUrl, icons } = biggestBuildersPromos;
  const isDesktop = deviceType === 'desktop';
  const Heading = isDesktop ? ArticleHeading2 : ArticleHeading3;
  const buildersLogo = icons.slice(0, MAX_ICONS);

  return (
    <a
      href={searchUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={clsx(styles['container'], styles[`container-${deviceType}`])}
      data-testid="BuildersPromotions"
    >
      <div>
        <Label background="theme-white" color="theme-dark">
          {label}
        </Label>
        <div className={styles['title']}>
          <Heading color="theme-dark">{title}</Heading>
        </div>
      </div>
      <div className={styles['logo-block']}>
        {buildersLogo.map(icon => (
          <div
            key={icon}
            className={clsx(styles['logo'], styles[`logo-${deviceType}`])}
            style={{ backgroundImage: `url("${icon}")` }}
          />
        ))}
      </div>
    </a>
  );
};
